function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
(function () {
  'use strict';

  angular.module('wsLrs.directives').
  /**
   * Quick recipes:
   *
   * Transparent Icon-Only Button:
   *      <icon-button icon="<icon>" variant="icon-only"></icon-button>
   *
   * Attributes:
   * @param icon string The Font Awesome icon to be used in this button => class="fa fa-<icon>"... https://fontawesome.com/icons
   * @param btnClasses {string} Space-separated list of classes to be applied to the button
   * @param variant {string} Shorthand for quick btn class: i.e. variant="block" => <button class="btn-block"...
   * @param size {enum<string>} Optional size declaration for icon. Choices are: xs, sm, lg, 2x, 3x, 5x, 7x, 10x
   * @param spacing {enum<string>} Declaration of margin beside an icon. Choices: 'left', 'right'
   *
   * @param spin {boolean} Determines the application of the 'fa-spin' class
   * @param pulse {boolean} Determines the application of the 'fa-pulse' class
   */

  directive('iconButton', [function () {
    return {
      replace: true,
      transclude: true,
      scope: {
        'icon': '<',
        'spin': '<',
        'pulse': '<',
        'prefix': '<'
      },
      template: "\n                <button class=\"{{ btnClasses }}\">\n                    <i class=\"{{ iconClasses }}\" ng-class=\"{ 'fa-spin': spin, 'fa-pulse': pulse }\"></i>\n                    <ng-transclude></ng-transclude>\n                </button>\n            ",
      link: function link(scope, elem, attrs) {
        // Allow setting a different btn-<variant> but default to btn-default
        var variant = hasAttr('variant') ? "btn-".concat(attrs.variant) : 'btn-default';
        var additionalClasses = hasAttr('btnClasses') ? attrs.btnClasses : '';

        // Init icon to the attr string literal or empty
        var icon = hasAttr('icon') ? attrs.icon : '';

        // If icon is defined on scope, that means it is dynamic.
        // So we'll use the scope definition rather than the string literal
        if (scope.icon) {
          icon = scope.icon;
        }

        // Set a watcher on icon in case it changes
        scope.$watch('icon', function (newIcon) {
          if (newIcon !== undefined && newIcon !== 0) {
            scope.iconClasses = getIconClasses(newIcon);
          }
        });
        scope.iconClasses = getIconClasses(icon);

        // Apply all the accumulated classes to the scope, along with default .btn class
        scope.btnClasses = "".concat(additionalClasses, " ").concat(variant, " btn");
        if (hasAttr('spacing')) {
          switch (attrs.spacing) {
            case 'left':
              scope.iconClasses = "".concat(scope.iconClasses, " ml-2");
              break;
            case 'right':
              scope.iconClasses = "".concat(scope.iconClasses, " mr-2");
              break;
            default:
              return;
          }
        }
        function hasAttr(attr) {
          return Object.keys(attrs).includes(attr);
        }

        /**
         * Generate the list of icon classes to apply based on different attributes and factors
         * @param string icon - classname to apply to the list of iconClasses
         *          ex. "trash", "plus", "edit"
         * @returns {string} Space-separated list of icon classes to apply to the <i> element
         */
        function getIconClasses(icon) {
          var fontStyle = scope.prefix || 'fas';
          var classes = [fontStyle];
          if (!icon) {
            throw Error('You must define icon either with a scope variable or a string literal, but it ' + 'looks like the attr is either undefined or empty');
          }
          if (hasAttr('iconClasses')) {
            classes.push.apply(classes, _toConsumableArray(attrs.iconClasses.split(' ')));
          }
          if (hasAttr('size')) {
            classes.push("fa-".concat(attrs.size));
          }
          classes.push(getIconMargin());
          classes.push("fa-".concat(icon));
          return classes.join(' ');
        }
        function getIconMargin() {
          // If there is text within a button, it defaults to mr-2 but if it's just
          // an icon it will not put any margin so it is centered correctly.
          return elem.text().trim().length > 0 ? 'mr-2' : '';
        }
      }
    };
  }]);
})();
